import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function ArabicLettersAndNumbersOnly(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const valueOfControl: string = control.value;
    if (!valueOfControl) {
      return null;
    }
    const cleanText = valueOfControl
                        .replace(/<\/?[^>]+(>|$)/g, '') // Remove HTML tags
                        .replace(/&nbsp;/g, ' '); // Replace &nbsp; with space
    const arabicLettersAndNumbersRegex = /[\u0600-\u06FF\u0750-\u077F\u08A0-\u08FF\uFB50-\uFDFF\uFE70-\uFEFF\u0660-\u0669\u06F0-\u06F9#]+/;
    const isValid = arabicLettersAndNumbersRegex.test(cleanText) && !/[A-Za-z]/.test(cleanText);
    return isValid ? null : { allowArabicLettersAndNumbersOnly: true };
  };
}
